import { TbEye, TbEyeOff } from "react-icons/tb";

import { CommonStatusItem, PassengerExtras } from "@/types/global";

import { softColors } from "./colors";

export type PassengerWelcomeVisibilityItem = CommonStatusItem & {
    label: string;
    value: PassengerExtras;
};

export type PassengerWelcomeVisibilityList = PassengerWelcomeVisibilityItem[];

export const passengerWelcomeTeamVisibilities: PassengerWelcomeVisibilityList = [
    {
        label: "Gösterme",
        value: PassengerExtras.HIDE_FOR_WELCOME_TEAM,
        component: () => TbEyeOff,
        ...softColors.brown,
        tooltip: {
            title: "Manuel Yolcu",
            description: "Yolcu karşılama ekibi tarafından görülemez.",
        },
    },
    {
        label: "Göster",
        value: PassengerExtras.DEFAULT,
        component: () => TbEye,
        ...softColors.green,
        tooltip: {
            title: "Karşılama Ekibine Göster",
            description: "Yolcu karşılama ekibi tarafından görülebilir.",
        },
    },
];
